import { dew as _isValueDew } from "./is-value";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var isValue = _isValueDew();

  var map = {
    function: true,
    object: true
  };

  exports = function (value) {
    return isValue(value) && map[typeof value] || false;
  };

  return exports;
}